<template>
    <div class="section-header" :class="stackClass">
        <component :is="tag" class="section-title">{{ title }}</component>
        <div v-if="$slots.default" class="section-header-right">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageHeader',
    props: {
        title: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            default: 'h1',
            validator: (value) => ['h1', 'h2'].includes(value),
        },
        stackUntil: {
            type: String,
            default: '',
            validator: (value) => ['', 'md'].includes(value),
        },
    },
    computed: {
        stackClass() {
            return this.stackUntil ? `section-header--stack-${this.stackUntil}` : null;
        },
    },
};
</script>
